import { useEffect } from "react";

import SalesQuoteList from "../../components/salesQuotes/SalesQuoteList";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function SalesQuotes() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Sales Quotes",
      desc: "Baskets saved for a customer to come back to",
    });
  }, []);

  return (
    <div className="bg-white shadow rounded-lg mt-4 overflow-hidden">
      <SalesQuoteList />
    </div>
  );
}
